var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import "./MainView.component.css";
import { AvatarDisplay } from "../../components/avatar-display/AvatarDisplay.component";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SessionSelect } from "../../components/session-select/SessionSelect.component";
import { CreateSessionDialog } from "../../dialogs/create-session-dialog/CreateSessionDialog.component";
import { useSessionSelectHandlers } from "../../hooks/session-select-handler.hook";
import { MessageService } from "../../services/message.service";
import { usersService } from "../../../modules/multiplayer/UsersService";
import { WorldContainer } from "../../components/world-container/WorldContainer.component";
import { useMediaDevicesStore } from "../../store/media-devices.store";
import { CameraSelect } from "../../components/device-settings/camera-select/CameraSelect.component";
import { AudioSettings } from "../../components/device-settings/audio-settings/AudioSettings.component";
import { MenuIconButton } from "../../components/menu-icon-button/MenuIconButton.component";
import { toUserAvatar, useAvatarConfigStore } from "../../store/avatar-config.store";
import { AvatarSettingsDialog } from "../../dialogs/avatar-settings-dialog/AvatarSettingsDialog.component";
import { OptionsDialog } from "../../dialogs/options-dialog/OptionsDialog.component";
import { useTranslation } from "react-i18next";
var MainViewDialogType;
(function (MainViewDialogType) {
    MainViewDialogType[MainViewDialogType["none"] = 0] = "none";
    MainViewDialogType[MainViewDialogType["createSession"] = 1] = "createSession";
    MainViewDialogType[MainViewDialogType["options"] = 2] = "options";
    MainViewDialogType[MainViewDialogType["sessionSettings"] = 3] = "sessionSettings";
    MainViewDialogType[MainViewDialogType["editAvatar"] = 4] = "editAvatar";
})(MainViewDialogType || (MainViewDialogType = {}));
var MainViewPopupType;
(function (MainViewPopupType) {
    MainViewPopupType[MainViewPopupType["none"] = 0] = "none";
    MainViewPopupType[MainViewPopupType["audioSettings"] = 1] = "audioSettings";
    MainViewPopupType[MainViewPopupType["cameraSettings"] = 2] = "cameraSettings";
})(MainViewPopupType || (MainViewPopupType = {}));
export function MainView() {
    const [userName, setUserName] = useState("");
    const [currentDialog, setCurrentDialog] = useState(MainViewDialogType.none);
    const [currentPopup, setCurrentPopup] = useState(MainViewPopupType.none);
    const popupContainerRef = useRef(null);
    const usernameInputRef = useRef(null);
    const mediaDevices = useMediaDevicesStore();
    const avatarStore = useAvatarConfigStore();
    const { targetSession, targetSessionName, handleSessionSelectionChanged, handleSessionCreated, switchSession, handleDeleteSession } = useSessionSelectHandlers(() => { }, () => {
        setCurrentDialog(MainViewDialogType.none);
    });
    const { t } = useTranslation();
    useEffect(() => {
        var _a, _b;
        const name = (_a = usersService.getCustomUsername()) !== null && _a !== void 0 ? _a : "";
        setUserName(name);
        if (!name) {
            (_b = usernameInputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, []);
    useEffect(() => {
        if (currentPopup === MainViewPopupType.none) {
            setTimeout(() => {
                window.removeEventListener("click", closePopupListener);
            }, 1);
        }
        else {
            setTimeout(() => {
                window.addEventListener("click", closePopupListener);
            }, 1);
        }
    }, [currentPopup]);
    useEffect(() => {
        if (userName) {
            usersService.setGuestUserInfo(userName, toUserAvatar(avatarStore.avatar));
        }
    }, [userName]);
    const openPopup = (event, popup) => __awaiter(this, void 0, void 0, function* () {
        event.stopPropagation();
        if (currentPopup === popup) {
            setCurrentPopup(MainViewPopupType.none);
        }
        else {
            setCurrentPopup(popup);
        }
    });
    const closePopupListener = (e) => {
        if (popupContainerRef.current && !popupContainerRef.current.contains(e.target)) {
            const portals = document.getElementsByClassName("select-menu-portal");
            // The select menus are appended directly to body, so we need to separately check if the click was inside a menu
            if (portals.length > 0 && portals[0].contains(e.target)) {
                return;
            }
            setCurrentPopup(MainViewPopupType.none);
            window.removeEventListener("click", closePopupListener);
        }
    };
    const requestDeleteSession = (session) => {
        MessageService.showConfirmationDelete(t("landingpage:confirm-delete-session", 'Are you sure you want to delete the session "{{sessionName}}"?', { sessionName: session.name }), () => {
            handleDeleteSession(session);
        });
    };
    const onUsernameChanged = (event) => {
        setUserName(event.target.value);
    };
    return (React.createElement("div", { className: "mainview" },
        React.createElement("aside", { className: "mainview-sidebar" },
            React.createElement("div", { className: "mainview-sidebar-header" },
                React.createElement("img", { className: "mainview-flavr-logo", src: "/FlaVR_Final_White.svg", alt: "FlaVR Logo" }),
                React.createElement("h1", null, t("landingpage:header", "Join Session"))),
            React.createElement("div", { className: "mainview-sidebar-contents" },
                React.createElement(SessionSelect, { sessionName: targetSessionName, onSelectionChanged: handleSessionSelectionChanged, onCreateClicked: () => {
                        setCurrentDialog(MainViewDialogType.createSession);
                    }, deleteVisible: true, onDeleteClicked: requestDeleteSession }),
                React.createElement("section", { className: "mainview-sidebar-row" },
                    React.createElement("div", { className: "mainview-avatar-small" },
                        React.createElement(AvatarDisplay, { username: userName })),
                    React.createElement("button", { onClick: () => {
                            setCurrentDialog(MainViewDialogType.editAvatar);
                        }, "data-tooltip": t("landingpage:button-edit-avatar-tooltip", "Edit your appearance in the 3D world") },
                        React.createElement(FontAwesomeIcon, { icon: ["fas", "edit"] }),
                        React.createElement("span", null, t("landingpage:button-edit-avatar", "Edit Avatar"))),
                    React.createElement("div", { className: "mainview-sidebar-spacer" })),
                React.createElement("input", { type: "text", className: userName ? "" : "input-warn-state", placeholder: t("landingpage:input-name-placeholder", "Please enter your name"), onChange: onUsernameChanged, ref: usernameInputRef, value: userName }),
                React.createElement("section", { className: "mainview-sidebar-row" },
                    React.createElement(MenuIconButton, { mainIcon: mediaDevices.mic.enabled ? "microphone" : "microphone-slash", subIcon: "angle-up", onClick: () => {
                            mediaDevices.mic.setEnabled(!mediaDevices.mic.enabled, true);
                        }, onSubIconClick: (e) => __awaiter(this, void 0, void 0, function* () {
                            yield openPopup(e, MainViewPopupType.audioSettings);
                        }), mainTooltip: mediaDevices.mic.enabled
                            ? t("landingpage:button-microphone-setting-tooltip-enabled", "Microphone is enabled (Click to disable)")
                            : t("landingpage:button-microphone-setting-tooltip-disabled", "Microphone is disabled (Click to enable)"), subTooltip: t("landingpage:button-microphone-setting-secondary-tooltip", "Choose the microphone to use") }),
                    React.createElement(MenuIconButton, { mainIcon: mediaDevices.cam.enabled ? "video" : "video-slash", subIcon: "angle-up", onClick: () => {
                            mediaDevices.cam.setEnabled(!mediaDevices.cam.enabled, true);
                        }, onSubIconClick: (e) => __awaiter(this, void 0, void 0, function* () {
                            yield openPopup(e, MainViewPopupType.cameraSettings);
                        }), mainTooltip: mediaDevices.cam.enabled
                            ? t("landingpage:button-camera-setting-tooltip-enabled", "Camera is enabled (Click to disable)")
                            : t("landingpage:button-camera-setting-tooltip-disabled", "Camera is disabled (Click to enable)"), subTooltip: t("landingpage:button-camera-setting-secondary-tooltip", "Choose the camera to use") }),
                    React.createElement("div", { className: "mainview-sidebar-spacer" })),
                React.createElement("button", { disabled: !targetSession || !userName, className: "highlight-button", onClick: switchSession, "data-tooltip-disabled": t("landingpage:button-join-session-tooltip-disabled", "Please select a session and enter your name") }, t("landingpage:button-join-session", "Join Session")),
                React.createElement("button", { type: "button", onClick: () => {
                        setCurrentPopup(MainViewPopupType.none);
                        setCurrentDialog(MainViewDialogType.options);
                    } },
                    React.createElement(FontAwesomeIcon, { icon: ["fas", "cog"] }),
                    React.createElement("span", null, t("settings:dialog-title", "Settings"))))),
        React.createElement("main", { className: "mainview-content" },
            React.createElement(WorldContainer, null,
                React.createElement("div", { className: "mainview-content-overlay" },
                    currentPopup !== MainViewPopupType.none && currentDialog === MainViewDialogType.none && (React.createElement("div", { className: "mainview-popup-container", ref: popupContainerRef },
                        React.createElement("h2", null, currentPopup === MainViewPopupType.audioSettings
                            ? t("landingpage:popup-audio-settings-header", "Audio settings")
                            : t("landingpage:popup-camera-settings-header", "Camera settings")),
                        currentPopup === MainViewPopupType.cameraSettings && React.createElement(CameraSelect, { noPrivacyWarning: true, noExtendedSettings: true }),
                        currentPopup === MainViewPopupType.audioSettings && React.createElement(AudioSettings, { noPrivacyWarning: true, noExtendedSettings: true }))),
                    currentDialog === MainViewDialogType.createSession && (React.createElement(CreateSessionDialog, { onCancel: () => {
                            setCurrentDialog(MainViewDialogType.none);
                        }, onCreated: handleSessionCreated })),
                    currentDialog === MainViewDialogType.editAvatar && (React.createElement(AvatarSettingsDialog, { username: userName, onClose: () => {
                            setCurrentDialog(MainViewDialogType.none);
                        } })),
                    currentDialog === MainViewDialogType.none && (React.createElement("div", { className: "mainview-avatar-large" },
                        React.createElement(AvatarDisplay, { username: userName })))))),
        currentDialog === MainViewDialogType.options && (React.createElement("div", { className: "mainview-dialogs" },
            React.createElement(OptionsDialog, { username: userName, onClose: () => {
                    setCurrentDialog(MainViewDialogType.none);
                } })))));
}
